<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="/home" title="Home">CNA Box</a></li>
                            <li>Estoque</li>
                        </ul>
                    </section>
                    <section class="col-sm-6">
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openCreate()">
                            Criar
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Estoque</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">

                                <div class="form-group col-md-6">
                                    <label for="nome">Nome</label>
                                    <input type="text" class="form-control" name="nome" placeholder="Nome" v-model="filter.nome" />
                                </div>

                                <div class="form-group col-md-6">
                                    <label for="unidadeMedidaId">Unidade de Medida</label>
                                    <select v-select="{ dataitem: 'UnidadeMedida', default: 'Todos' }" v-model="filter.unidadeMedidaId" class="form-control" name="unidadeMedidaId"></select>
                                </div>

                                <div class="form-group col-md-6">
                                    <label for="categoriaEstoqueId">Categoria de Estoque</label>
                                    <select v-select="{ dataitem: 'CategoriaEstoque', default: 'Todos' }" v-model="filter.categoriaEstoqueId" class="form-control" name="categoriaEstoqueId"></select>
                                </div>

                                <div class="form-group col-md-6">
                                    <label for="Escola">Escola</label>
                                    <select v-select="{ dataitem: 'Escola', default: 'Todos' }" v-model="filter.escolaId" class="form-control" name="escolaId"></select>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Ativo</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ativo" v-model="filter.ativo" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Venda</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="venda" v-model="filter.venda" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="venda" v-model="filter.venda" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="venda" v-model="filter.venda" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Compra SOMENTE Via CNA Store</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="compraViaCNAStore" v-model="filter.compraViaCNAStore" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="compraViaCNAStore" v-model="filter.compraViaCNAStore" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="compraViaCNAStore" v-model="filter.compraViaCNAStore" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="form-group col-md-6">
                                    <label>Apenas materiais digital</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehMaterialDigital" v-model="filter.ehMaterialDigital" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehMaterialDigital" v-model="filter.ehMaterialDigital" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio custom-control-inline">
                                            <input type="radio" name="ehMaterialDigital" v-model="filter.ehMaterialDigital" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Id<i @click="executeOrderBy('estoqueItemId')" class="fa fa-sort"></i></th>
                                    <th>Referência CNA Store<i @click="executeOrderBy('referenciaCNAStore')" class="fa fa-sort"></i></th>
                                    <th>Nome<i @click="executeOrderBy('Nome')" class="fa fa-sort"></i></th>
                                    <th>Unidade<i @click="executeOrderBy('unidadeMedida.nome')" class="fa fa-sort"></i></th>
                                    <th>Categoria<i @click="executeOrderBy('categoriaEstoque.nome')" class="fa fa-sort"></i></th>
                                    <th>Ativo<i @click="executeOrderBy('Ativo')" class="fa fa-sort"></i></th>
                                    <th>Venda<i @click="executeOrderBy('Venda')" class="fa fa-sort"></i></th>
                                    <th>Compra SOMENTE Via CNA Store<i @click="executeOrderBy('CompraViaCNAStore')" class="fa fa-sort"></i></th>
                                    <th>Apenas materiais digital<i @click="executeOrderBy('ehMaterialDigital')" class="fa fa-sort"></i></th>

                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.estoqueItemId }}</td>
                                    <td>{{ item.referenciaCNAStore }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td>{{ item.unidadeMedida.nome }}</td>
                                    <td>{{ item.categoriaEstoque.nome }}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ativo, 'badge-danger': !item.ativo }">{{item.ativo ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.venda, 'badge-danger': !item.venda }">{{item.venda ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.compraViaCNAStore, 'badge-danger': !item.compraViaCNAStore }">{{item.compraViaCNAStore ? 'Sim' : 'Não'}}</span></td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.ehMaterialDigital, 'badge-danger': !item.ehMaterialDigital }">{{item.ehMaterialDigital ? 'Sim' : 'Não'}}</span></td>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" v-b-tooltip title="Editar" @click="openEdit({ estoqueItemId: item.estoqueItemId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Remover" @click="openRemove({ estoqueItemId: item.estoqueItemId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>
		
        <b-modal :no-close-on-backdrop="true" size="lg" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" size="lg" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="estoqueItemId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'
    
    export default {
        name: 'estoqueitem',
        mixins: [base],
        components: { formCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'estoqueitem',
                    remove: 'estoqueitem'
                },

				dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.estoqueItemId = model.estoqueItemId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>